import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';

import PanelActions from '../actions/panel';
import CustomCheckbox from './custom-checkbox';
import {Img} from 'apps/shared/components';

const CoverImage = createClass({

  propTypes: {
    className: PropTypes.string,
    onClick: PropTypes.func,
    onToggle: PropTypes.func,
    active: PropTypes.bool,
    zoom: PropTypes.bool,
    srcImage: PropTypes.string,
    onRemove: PropTypes.func
  },

  getDefaultProps() {
    return {
      zoom: true
    };
  },

  showGallery() {
    const {srcImage} = this.props;
    PanelActions.displayOnGallery([srcImage]);
  },

  handleRemove(evt) {
    evt.stopPropagation();
    if (this.props.onRemove) this.props.onRemove(evt);
  },

  handleToggle(evt) {
    evt.stopPropagation();
    if (this.props.onToggle) this.props.onToggle(evt);
  },

  render() {
    const {className, onToggle, active, zoom, onRemove, srcImage, style} = this.props;
    const containerStyle = style;

    let classes = 'vf-coverimage margin-right-Hx vf-clickable';
    if (className) classes += ' ' + className;

    return (
      <div
        className={classes}
        onClick={zoom && this.showGallery}
        style={containerStyle}
        key={srcImage}
      >

        <Img
          src={srcImage}
          className='image-cover image-fit-parent'
          width={135}
          height={135}
        />

        {zoom && (
          <button className='vf-coverimage-hover'>
            <div className='icon-expand' />
          </button>
        )}

        {onRemove && (
            <div className='vf-coverimage-overlay vf-clickable' onClick={this.handleRemove}>
              <i className='vf-icon icon-close' />
            </div>
          )
        }

        {onToggle && <CustomCheckbox value={active} onChange={this.handleToggle}/>}
      </div>
    );
  }

});

module.exports = CoverImage;
